import React from 'react';
import { CreditPackageProduct } from '../../models/CreditPackageProduct';
import ProductDescriptionTooltip from './ProductDescriptionTooltip';

interface CreditProductListProps {
  products: CreditPackageProduct[];
  selectedProduct: CreditPackageProduct | null;
  onProductSelect: (product: CreditPackageProduct) => void;
  isLoading: boolean;
  disabled?: boolean;
}

interface ProductCardProps {
  product: CreditPackageProduct;
  isSelected: boolean;
  disabled: boolean;
  onSelect: () => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, isSelected, disabled, onSelect }) => {
  return (
    <div
      className={`product-card ${isSelected ? 'product-card-selected' : ''} ${disabled ? 'product-card-disabled' : ''}`}
      onClick={onSelect}
    >
      <div className="product-card-content">
        <div className="product-name-wrapper">
          <div className="product-name">
            {product.title}
          </div>
        </div>
        <div className="product-price-wrapper">
          <div className="product-price">
            ${product.price.toFixed(2)}
          </div>
          {product.description && (
            <ProductDescriptionTooltip 
              description={product.description} 
              productId={product.id}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const CreditProductList: React.FC<CreditProductListProps> = ({ 
  products, 
  selectedProduct, 
  onProductSelect, 
  isLoading, 
  disabled = false 
}) => {
  if (isLoading) {
    return (
      <section className="checkout-highlights">
        <div className="text-center py-4">
          <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
        </div>
      </section>
    );
  }

  if (products.length === 0) {
    return null;
  }

  return (
    <section className="checkout-highlights">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          isSelected={selectedProduct?.id === product.id}
          disabled={disabled}
          onSelect={() => !disabled && onProductSelect(product)}
        />
      ))}
    </section>
  );
};

export default CreditProductList;

